import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Global } from '../global';

export interface MonthlyCost {
  mes: string;
  mes_numero: number;
  year: number;
  costo: number;
}

export interface DailyCost {
  day: number;
  date: string;
  cost: number;
}

export interface MonthData {
  year: number;
  month: number;
  month_name: string;
  daily_costs: DailyCost[];
  total: number;
}

export interface MonthlyComparison {
  current_month: MonthData;
  previous_month: MonthData;
  comparison: {
    difference: number;
    percentage_change: number;
  };
}

export interface ServiceCost {
  service: string;
  cost: number;
  cost_with_partner: number;
}

export interface ServiceVariation {
  nombre: string;
  descripcion: string;
  monto_cambio: string;
  tipo: string;
}

export interface ComparativaPunto {
  titulo: string;
  descripcion: string;
}

export interface AIAnalysisSeccion1 {
  titulo: string;
  puntos: ComparativaPunto[];
}

export interface AIAnalysisSeccion2 {
  titulo: string;
  servicios: ServiceVariation[];
}

export interface AIAnalysisSeccion3 {
  titulo: string;
  estimado_cierre: {
    minimo: number;
    maximo: number;
  };
  tendencia: string;
  analisis_detallado: string;
}

export interface AIAnalysisResumen {
  mes_reciente: string;
  mes_comparacion: string;
  costo_mes_reciente: number;
  costo_mes_comparacion: number;
  diferencia: number;
  porcentaje_cambio: number;
}

export interface AIAnalysis {
  seccion_1_comparativa: AIAnalysisSeccion1;
  seccion_2_variacion_servicios: AIAnalysisSeccion2;
  seccion_3_proyeccion: AIAnalysisSeccion3;
  resumen_ejecutivo: AIAnalysisResumen;
}

export interface CostData {
  'Total 2024': MonthlyCost[];
  'Total 2025': MonthlyCost[];
  'Total 2026': MonthlyCost[];
  monthly_comparison: MonthlyComparison;
}

export interface CostMetadata {
  partner_discount: number;
  partner_percentage: number;
  ai_model: string;
  note: string;
}

export interface MarketplaceCost {
  account_id: string;
  year: number;
  month: number;
  start_date: string;
  end_date: string;
  cost: number;
}

export interface CostSummaryResponse {
  success: boolean;
  data: CostData;
  ai_analysis: AIAnalysis;
  metadata: CostMetadata;
  costs_by_service_current: ServiceCost[];
  costs_by_service_previous: ServiceCost[];
  marketplace_cost_referencia?: MarketplaceCost;
  marketplace_cost_comparacion?: MarketplaceCost;
}

@Injectable({
  providedIn: 'root'
})
export class AwsCostosService {

  private readonly API_URL: string;

  constructor(
    private readonly httpClient: HttpClient
  ) {
    this.API_URL = Global.url + '/costs/summary';
  }

  getCostsSummary(token: string, mesReferencia?: string, mesComparacion?: string): Observable<CostSummaryResponse> {
    let params: { [key: string]: string } = {};
    if (mesReferencia) {
      params['mes_referencia'] = mesReferencia;
    }
    if (mesComparacion) {
      params['mes_comparacion'] = mesComparacion;
    }

    return this.httpClient.get<CostSummaryResponse>(this.API_URL, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      params
    })
      .pipe(
        tap(response => {
          console.log('Costos obtenidos exitosamente');
        }),
        catchError(error => {
          console.error('Error al obtener costos:', error);
          throw error;
        })
      );
  }
}
